export const getters = {
    getBlogPosts: state => state.blogArray,
    getBlogUpdate: state => state.blogUpdate,
    getBlogInsert: state => state.blogInsert,
    getBlogDelete: state => state.blogDelete,
    getBlogMessage: state => state.blogMessageArray
}